import { styled, css } from '../../components-v4/theme';

export const Wrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const MobileHeader = styled.div`
  ${({ theme }) => css`
    position: relative;
    display: flex;
    align-items: center;
    gap: ${theme.spacings.base};
  `}
`;

export const MobileHeaderClose = styled.div`
  ${({ theme }) => css`
    position: absolute;
    left: 0;
    display: flex;
    align-items: center;
    gap: ${theme.spacings.xxs};
    color: ${theme.colors.primary[600]};
    cursor: pointer;
  `}
`;
